import { actionTypes } from 'redux-resource';
import * as api from 'api';

export const fetchLoginDevices =
  (email, page = 1) =>
  (dispatch) => {
    const actionDefaults = {
      resourceType: 'loginDevices',
      requestKey: `fetchLoginDevices${page}`,
      list: `fetchLoginDevices${page}`,
      mergeListIds: false,
    };

    dispatch({
      ...actionDefaults,
      type: actionTypes.READ_RESOURCES_PENDING,
    });

    return api
      .fetchLoginDevices({ email, page })
      .then(({ data }) => {
        const { count, next, previous } = data;

        let results = [];
        if (data.results && data.results.length) {
          results = data.results.map((item) => ({
            ...item,
            id: item.uid,
          }));
        }

        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_SUCCEEDED,
          resources: results,
          requestProperties: {
            perPage: data.results.length,
            count,
            next,
            previous,
          },
        });
      })
      .catch((err) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_FAILED,
        });
      });
  };
